/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
/* eslint-disable eslint-comments/no-restricted-disable */

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { expVal } from '@atlassian/jira-feature-experiments';
import { IdentityUserAri } from '@atlassian/ari/identity/user';
import { JiraNavigationSettingsAri } from '@atlassian/ari/jira/navigation-settings';
import { fg } from '@atlassian/jira-feature-gating';
import { NavigationSettingAri } from '@atlassian/ari/navigation/setting';
import type { Nav4PlansListViewQueryEntrypointProps } from './Nav4PlansListViewQuery.entrypoint.types.tsx';
import parameters, {
	type Nav4PlansListViewQuery,
} from './__generated__/Nav4PlansListViewQuery.graphql';
import type { EntryPointParams } from './Nav4PlansListViewQuery.tsx';

type Queries = { queryRef: Nav4PlansListViewQuery };

type AsyncPlansSectionPlanListViewQueryComponent = EntryPointComponent<
	Queries,
	{},
	Nav4PlansListViewQueryEntrypointProps,
	{}
>;

export const asyncPlansSectionPlanListViewQuery: EntryPoint<
	AsyncPlansSectionPlanListViewQueryComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<AsyncPlansSectionPlanListViewQueryComponent>(
		/* webpackChunkName: "async-projects-section-content-view-query" */ './Nav4PlansListViewQuery.tsx',
	),
	getPreloadProps: (params: EntryPointParams) => {
		const cloudId = params.cloudId;

		const variables = expVal('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false)
			? (() => {
					const activationId = params.activationId || '';
					const entityAriPlans = fg('navx-3660-fix-l2-l3-aris')
						? NavigationSettingAri.create({
								activationId,
								firstPartyApp: 'jira',
								settingId: 'plans',
								siteId: cloudId,
							}).toString()
						: JiraNavigationSettingsAri.create({
								siteId: cloudId,
								activationId,
								navigationSettingScope: 'plans',
							}).toString();

					return {
						cloudId,
						ownerAri: IdentityUserAri.create({
							userId: params.accountId || 'UNKNOWN',
						}).toString(),
						entityAriPlans,
						skipOrderQuery: false,
					};
				})()
			: {
					cloudId,
					ownerAri: '',
					entityAriPlans: '',
					skipOrderQuery: true,
				};
		return {
			queries: {
				queryRef: {
					parameters,
					variables,
				},
			},
		};
	},
});
